import { useAuth } from 'core/context/AuthContext/AuthContextProvider';
import httpclient from 'libs/Axios';
import { useEffect } from 'react';

export const useFetchBranchDetails = (list, setData, isTrue) => {
    const authData = useAuth();
    useEffect(() => {
        const request = async () => {
            const response = await httpclient().get(`/data/branch/view?id=${authData?.BRANCH_ID}&page_size=500&page_index=1`);
            const data = response?.data?.data;
            setData(data);
        };
        if (isTrue && authData?.BRANCH_ID) {
            request();
        }
    }, [authData?.BRANCH_ID, isTrue]);
};
